<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'app'
}
</script>

<style lang="scss">
/*
  @import url('http://fonts.googleapis.com/css?family=Carrois+Gothic');
  @import url('http://fonts.googleapis.com/css?family=Open+Sans:400,700');

  @import 'assets/css/bootstrap.min.css';
  @import 'assets/css/plugins.css';
  @import 'assets/style.css';
  @import 'assets/css/custom.css';
*/

</style>
                                                                            
